import React, {ReactNode} from 'react'
import {DialogComponent, DialogParams} from '../pageBaseComponents/DialogComponent'
import {Nullable} from '../../../app/TypeHelpers'
import EventEmitterExAdmin from '../pageBaseComponents/EventEmitterExAdmin'

interface ExternalProps {
    eventEmitter: EventEmitterExAdmin
}

export const withDialog = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;

    interface State {
        open: boolean
        params: Nullable<DialogParams>
    }

    return class extends React.Component<ResultProps, State> {
        static displayName: string = `withDialog(${WrappedComponent.displayName})`

        constructor(props: Readonly<OriginalProps & ExternalProps>) {
            super(props)
            this.state = {
                open: false,
                params: null,
            }
            this.handleShowDialog = this.handleShowDialog.bind(this)
            this.handleCloseDialog = this.handleCloseDialog.bind(this)
        }

        componentDidMount(): void {
            this.props.eventEmitter.on('showDialog', this.handleShowDialog)
            this.props.eventEmitter.on('closeDialog', this.handleCloseDialog)
        }

        componentWillUnmount(): void {
            this.props.eventEmitter.off('showDialog', this.handleShowDialog)
            this.props.eventEmitter.off('closeDialog', this.handleCloseDialog)
        }

        handleShowDialog(params: DialogParams): void {
            this.setState({
                open: true,
                params: params,
            })
        }

        handleCloseDialog(): void {
            this.setState({
                open: false,
                params: null,
            })
        }

        render(): ReactNode {
            return (
                <>
                    <DialogComponent
                        open={this.state.open}
                        params={this.state.params}
                    />
                    <WrappedComponent
                        {...this.props}
                    />
                </>
            )
        }
    }
}
